import { render, staticRenderFns } from "./Chara.vue?vue&type=template&id=09fccf92&scoped=true"
import script from "./Chara.vue?vue&type=script&lang=js"
export * from "./Chara.vue?vue&type=script&lang=js"
import style0 from "./Chara.vue?vue&type=style&index=0&id=09fccf92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fccf92",
  null
  
)

export default component.exports